import { createI18n } from 'vue-i18n';

import * as frTranslations from '@/assets/translations/fr';

const fr = Object.values(frTranslations).reduce((acc, val) => {
  return { ...acc, ...val };
}, {});

const messages = { fr };

export const i18n = createI18n({
  globalInjection: true,
  legacy: false, // set to `false` to use Composition API
  locale: 'fr',
  fallbackLocale: 'fr',
  warnHtmlMessage: false,
  messages
});
